import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const InvalidButton = styled.button`
  background-color: ${props => props.theme.invalid};
  border-radius: 5px;
  border: none;
  color: ${props => props.theme.enigmaWhite};
  font-size: ${props => props.theme.fontLg};
  height: 30px;
  line-height: 20px;
  margin: 5px;
  margin-right: 30px;
  text-align: center;
  width: 100px;
  div {
    margin: 0px auto;
    padding: 16px;
  }
`;

const ValidButton = styled(InvalidButton)`
  background-color: ${props => props.theme.valid};
`;

const IdContainer = styled.span`
  color: ${props => props.theme.enigmaBlack};
  font-family: 'GT Mono', monospace;
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
`;

function RecentAlert({ status, id }) {
  return (
    <div>
      {status === 0 && <ValidButton>Cleared</ValidButton>}
      {status !== 0 && <InvalidButton>Escalated</InvalidButton>}
      <IdContainer>{id}</IdContainer>
    </div>
  );
}

RecentAlert.propTypes = {
  status: PropTypes.number.isRequired,
  id: PropTypes.string.isRequired,
};

export default RecentAlert;
